import { render, staticRenderFns } from "./ohter.vue?vue&type=template&id=2455990e&scoped=true"
import script from "./ohter.vue?vue&type=script&lang=js"
export * from "./ohter.vue?vue&type=script&lang=js"
import style0 from "./ohter.vue?vue&type=style&index=0&id=2455990e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2455990e",
  null
  
)

export default component.exports